export default {
  id: 'teams_promote_jobs',
  title: 'Promote jobs',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_JOBS' ],
  description: 'Send up to 4 selected jobs to your employees so they can easily share them across their network.',
  body: {
    attachments: [ {
      id: 'return-button',
      contentType: 'application/vnd.microsoft.card.adaptive',
      name: null,
      thumbnailUrl: null,
      contentUrl: null,
      content: JSON.stringify({
        type: 'AdaptiveCard',
        $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
        version: '1.4',
        body: [
          {
            type: 'ColumnSet',
            columns: [
              {
                type: 'Column',
                width: 1,
                items: [
                  {
                    type: 'TextBlock',
                    text: 'Go to the platform to check out more jobs.',
                    wrap: true
                  },
                ]
              }
            ]
          }
        ],
        actions: [
          {
            type: 'Action.OpenUrl',
            title: 'Visit Platform for More',
            style: 'positive',
            url: '{{PLATFORM_LINK}}'
          }
        ]
      })
    } ],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <BLOCK_JOB>
        <attachment id='return-button'></attachment>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  blocks: {
    BLOCK_JOB: id => `<attachment id='${id}'></attachment>`,
  },
  attachment(id, jobShareType = 'default') {
    let content = {};
    const generateContent = (items) => ({
      type: 'AdaptiveCard',
      version: '1.5',
      $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
      body: [
        {
          type: 'Container',
          separator: true,
          items: [
            {
              type: 'ColumnSet',
              columns: [
                {
                  type: 'Column',
                  width: 'stretch',
                  items: [
                    {
                      type: 'TextBlock',
                      text: '{{JOB_[ID]_TITLE}}',
                      wrap: true,
                      weight: 'Bolder',
                      size: 'Medium'
                    },
                    {
                      type: 'TextBlock',
                      text: '{{JOB_[ID]_DESCRIPTION}}',
                      wrap: true
                    }
                  ]
                },
                {
                  type: 'Column',
                  width: 'auto',
                  items: [
                    {
                      type: 'Image',
                      url: '{{JOB_[ID]_IMAGE_URL}}',
                      size: 'Medium',
                      altText: '{{JOB_[ID]_TITLE}}'
                    }
                  ]
                }
              ]
            },
            ...items
          ]
        },
      ],
      msTeams: {
        width: 'Full'
      }
    });
    if (jobShareType === 'linkedin-only') {
      content = generateContent([
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'Share on LinkedIn',
              url: '{{JOB_[ID]_LINKEDIN_SHARE_LINK}}'
            }
          ]
        }
      ]);
    } else {
      content = generateContent([
        {
          type: 'TextBlock',
          text: 'Suggested Share Text:',
          wrap: true,
          weight: 'Bolder'
        },
        {
          type: 'TextBlock',
          text: '{{JOB_[ID]_SHARE_TEXT}}',
          wrap: true,
          isSubtle: true,
          spacing: 'Small'
        },
        {
          type: 'TextBlock',
          text: '👆 Copy the text above to share with your network',
          wrap: true,
          isSubtle: true,
          size: 'Small',
          spacing: 'Small'
        },
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'Share on LinkedIn',
              url: '{{JOB_[ID]_LINKEDIN_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Share on Facebook',
              url: '{{JOB_[ID]_FACEBOOK_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Share on X',
              url: '{{JOB_[ID]_TWITTER_SHARE_LINK}}'
            }
          ]
        },
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'Share on Messenger',
              url: '{{JOB_[ID]_MESSENGER_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Share on WhatsApp',
              url: '{{JOB_[ID]_WHATSAPP_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Copy Share Link',
              url: '{{JOB_[ID]_COPY_SHARE_LINK}}'
            }
          ]
        },
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'LinkedIn Matches',
              url: '{{JOB_[ID]_MATCH_LINK}}'
            }
          ]
        }
      ]);
    }
    const attachment = {
      id,
      contentType: 'application/vnd.microsoft.card.adaptive',
      name: null,
      thumbnailUrl: null,
      contentUrl: null,
      content: JSON.stringify(content)
    };

    return attachment;
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following jobs with your network to win rewards! ...',
      defaultValue: 'Share the following jobs with your network to win rewards!',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/promoteJobs.js